<template>
  <div class="grid-display">
    <div class="grid-display-header">
      <img class="profile-picture" src="@/assets/images/profilTiktok.png" alt="Profile picture" />
      <a href="https://www.tiktok.com/@clementinepoutine" target="_blank" rel="noopener noreferrer" style="font-weight:bold;margin-bottom: 0;margin-top: 0.5rem;">@clementinepoutine</a>
      <p style="margin-bottom: 0.5rem;font-weight: 400;">
        Bienvenue sur la vue gallerie! Cliquez sur la photo qui vous intéresse pour voir la recette :)
      </p>
    </div>
    <div class="recipes-grid">
      <div class="recipe-item" v-for="recipe in displayRecipes" :key="recipe.id" @click="recipeSelected(recipe.id)">
        <div class="recipe-image">
          <img :src="getImagePath(recipe.photoName, recipe.photoUrl)" :alt="recipe.name" />
          <div class="image-overlay">
            <div class="overlay-bottom">
              <h4 class="recipe-title">{{ recipe.name }}</h4>
              <p class="recipe-excerpt">{{ getRecipeExcerpt(recipe) }}</p>
              <div class="recipe-meta">
                <span class="meta-date">{{ formatDate(recipe.datePublication) }}</span>
                <div class="meta-tags">
                  <span 
                    v-for="categoryId in recipe.categories.slice(0, 2)" 
                    :key="categoryId"
                    class="meta-tag"
                  >
                    #{{ getCategoryName(categoryId) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FirebaseDataService from '../services/FirebaseDataService.js';
import RecipeCard from '../components/RecipeCard.vue'

export default {
  name: 'GridDisplay',
  components: {
    RecipeCard
  },
  data() {
    return {
      categories: [],
      displayRecipes: []
    };
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      try {
        // Load categories and recipes from Firebase
        this.categories = await FirebaseDataService.getCategories();
        const allRecipes = await FirebaseDataService.getRecipes();
        
        // Filter published recipes
        this.displayRecipes = allRecipes.filter(recipe => 
          recipe.published !== false && new Date(recipe.datePublication) <= new Date()
        );
        
        console.log('GridDisplay loaded:', this.displayRecipes.length, 'recipes');
      } catch (error) {
        console.error('Error loading data for GridDisplay:', error);
      }
    },
    
    recipeSelected(recipeId){
      this.$router.push(`/recipe/${recipeId}`)
    },
    
    getImagePath(photoName, photoUrl = null) {
      if (!photoName) return '';
      
      // If there's a Firebase URL (new uploads), use it directly
      if (photoUrl && photoUrl.includes('firebase')) {
        return photoUrl;
      }
      
      // Otherwise, try to load from local assets (existing images)
      try {
        return require(`@/assets/images/${photoName}`);
      } catch (error) {
        // If local image doesn't exist and we have a URL, try that
        if (photoUrl) {
          return photoUrl;
        }
        return '';
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-CA', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    getRecipeExcerpt(recipe) {
      // Extract text from HTML content
      const div = document.createElement('div');
      div.innerHTML = recipe.content;
      const text = div.textContent || div.innerText || '';
      return text.substring(0, 80) + '...';
    },
    getCategoryName(categoryId) {
      const category = this.categories.find(c => c.id === categoryId);
      return category ? category.nom : '';
    }
  }
}
</script>

<style scoped>
.grid-display{
  padding:1rem;
}

.grid-display-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center;
  padding: 0 2rem;
  text-align: center;
}

.profile-picture {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.recipes-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Mobile: 3 columns */
  gap: 3px;
}

/* Large screens: 4 columns */
@media (min-width: 1024px) {
  .recipes-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* Extra large screens: 5 columns */
@media (min-width: 1280px) {
  .recipes-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

/* Ultra wide screens: 6 columns */
@media (min-width: 1600px) {
  .recipes-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

.recipe-item {
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.recipe-item:hover {
  transform: scale(1.02);
}

.recipe-image {
  position: relative;
  overflow: hidden;
}

.recipe-image img {
  width: 100%;
  aspect-ratio: 3/4;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.recipe-item:hover .recipe-image img {
  transform: scale(1.1);
}

/* Image Overlay - Always visible */
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    transparent 50%,
    rgba(0,0,0,0.8) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 15px;
  color: white;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.recipe-item:hover .image-overlay {
  background: linear-gradient(
    to bottom,
    transparent 0%,
    transparent 40%,
    rgba(0,0,0,0.9) 100%
  );
}

.overlay-bottom {
  text-align: left;
}

.recipe-title {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 6px;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}

.recipe-excerpt {
  font-size: 0.75rem;
  opacity: 0.9;
  margin-bottom: 8px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.recipe-meta {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 0.7rem;
}

.meta-date {
  opacity: 0.8;
  font-weight: 500;
}

.meta-tags {
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
  color: #d7d7d7;
}

.meta-tag {
  background: rgba(255,255,255,0.2);
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 0.6rem;
}

/* Responsive adjustments for mobile */
@media (max-width: 768px) {
  .recipe-title {
    font-size: 0.6rem;
    font-weight: 500;
    margin-bottom: 0;
    padding: 4px 8px;
    border-radius: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.2;
    text-align: center;
  }
  
  .recipe-excerpt {
    display: none; /* Hide description on mobile */
  }
  
  .recipe-meta {
    display: none; /* Hide date and tags on mobile */
  }
  
  .image-overlay {
    padding: 8px;
    justify-content: center;
    background: linear-gradient(
      to bottom,
      transparent 0%,
      transparent 70%,
      rgba(0,0,0,0.7) 100%
    );
  }
  
  .recipe-item:hover .image-overlay {
    background: linear-gradient(
      to bottom,
      transparent 0%,
      transparent 70%,
      rgba(0,0,0,0.8) 100%
    );
  }
}
</style>